const Benefits = {
    BenefitsSection: {
        section: {
            backgroundColor: 'rgba(0, 37, 75, 1)',
            display: 'flex',
            flexDirection: 'column',
            fontFamily: 'Inter, sans-serif',
            justifyContent: 'center',
            p: { xs: '24px 20px', sm: '24px 40px' },
            width: '100%',
        },
        container: {
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            gap: '27px',
            justifyContent: 'space-between',
        },
        textContainer: {
            alignSelf: 'stretch',
            display: 'flex',
            minWidth: '240px',
            flexDirection: 'column',
            justifyContent: 'center',
            margin: 'auto 0',
            maxWidth: { xs: '100%', sm: 'none' },
            width: '40%',
        },
        heading: {
            color: '#fff',
            fontSize: '24px',
            fontWeight: 700,
            lineHeight: 1,
            m: 0,
        },
        subheading: {
            color: 'rgba(230, 239, 248, 1)',
            fontSize: '16px',
            fontWeight: 500,
            lineHeight: '22px',
            mt: '4px',
            whiteSpace: 'nowrap',
        },
        cardsContainer: {
            alignSelf: 'stretch',
            display: 'flex',
            minWidth: '240px',
            alignItems: 'start',
            gap: '16px',
            justifyContent: 'space-between',
            flexWrap: 'nowrap',
            overflowX: 'auto',
            width: '60%',
            margin: 'auto 0',
        },
    },
    BenefitsCard: {
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'start',
            width: '120px',
        },
        image: {
            aspectRatio: '1',
            objectFit: 'contain',
            objectPosition: 'center',
            width: '48px',
        },
        title: {
            color: 'rgba(230, 239, 248, 1)',
            fontSize: '12px',
            fontWeight: 700,
            textAlign: 'center',
            textTransform: 'uppercase',
            lineHeight: '18px',
            mt: '10px',
            whiteSpace: { xs: 'normal', sm: 'pre-line' },
        },
    },
};

export default Benefits;
